import { useState } from "react";
import useFaqT from "./useFaqT";
import ContactSupportModal from "../common/ContactSupportModal";
import { FAQ_COPY } from "../../constants/faq/faqStructure";

// ONE contact card, used twice (design F6 + closing band): as the search
// empty state (variant="empty", capped 620px) and inside the closing band
// (variant="closing"). The CTA opens the platform's EXISTING support form —
// the same ContactSupportModal the floating support button uses
// (App.js → POST /users/support/contact/) — reuse instead of a mailto
// (Ticket 2, LEAD_NOTES №8).
//
// Mobile (<md): the card stacks vertically and the CTA goes full width,
// ≥44px tall (design F7).
const FaqContactCard = ({ variant = "closing" }) => {
  const tr = useFaqT();
  const [supportOpen, setSupportOpen] = useState(false);
  const isEmpty = variant === "empty";

  return (
    <div
      className={`w-full border border-[#DDE0E5] flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between md:gap-6 ${
        isEmpty ? "max-w-[620px] bg-[#FAFBFC] md:p-6" : "bg-white md:p-7"
      }`}
    >
      <div className="flex flex-col gap-1.5">
        <div className={`font-semibold text-[#14171C] ${isEmpty ? "text-[16px]" : "text-[16px] md:text-[18px]"}`}>
          {tr(FAQ_COPY.contactTitle)}
        </div>
        <div className="text-[13px] md:text-[14px] text-[#5A626E]">{tr(FAQ_COPY.contactText)}</div>
      </div>
      <button
        type="button"
        onClick={() => setSupportOpen(true)}
        className="flex-none inline-flex min-h-[44px] items-center justify-center bg-[#1F5EFF] px-[18px] py-3 text-center text-[14px] font-medium text-white hover:bg-[#1543C6] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1F5EFF] focus-visible:ring-offset-2 md:px-[22px] md:text-[15px]"
      >
        {tr(FAQ_COPY.contactCta)}
      </button>

      <ContactSupportModal
        isOpen={supportOpen}
        onClose={() => setSupportOpen(false)}
        onSuccess={() => {}}
      />
    </div>
  );
};

export default FaqContactCard;
